import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	commentIconLabel: {
		id: 'search-page.comment-icon-label',
		defaultMessage: 'Comment',
		description: 'Label for the comment icon. ',
	},
});
